import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import React, { useState, useEffect } from "react";
import { 
  FaCalendarAlt, 
  FaClock, 
  FaPlus, 
  FaTrash, 
  FaTools,
  FaSave,
  FaEdit,
  FaInfoCircle,
  FaToggleOn,
  FaToggleOff,
  FaSignOutAlt,
  FaClipboardList,
  FaChevronDown,
  FaChevronUp
} from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { useAuth } from "../context/AuthContext";
import DatePicker from "react-datepicker";
import BaseSelect from "react-select";
import FixRequiredSelect from "./FixRequiredSelect";
import { db } from "../firebase";
import { 
  collection, 
  getDocs, 
  addDoc, 
  deleteDoc, 
  doc, 
  query, 
  where 
} from "firebase/firestore";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import sv from "date-fns/locale/sv";
import ConfigService from "../services/ConfigService";

const AdminPage = () => {
  const { logout } = useAuth();
  const [maintenanceBlocks, setMaintenanceBlocks] = useState([]);
  const [newBlock, setNewBlock] = useState({
    date: new Date(),
    startTime: "",
    endTime: "",
    cart: "",
    reason: "",
    type: "maintenance"
  });
  const [appConfig, setAppConfig] = useState({
    serviceName: "Cart Scheduler",
    maxBookingDays: 14,
    weekdayStartHour: 8,
    weekdayEndHour: 18,
    weekendStartHour: 10,
    weekendEndHour: 16,
    thursdaySpecialRules: true,
    maxBookingDuration: 2,
    availableCarts: [
      { id: "1", name: "Vagn 1 & 2" },
      { id: "2", name: "Vagn 3 & 4" }
    ],
    infoMessages: {
        enabled: true,
        messages: [
          {
            id: "thursday",
            weekdays: [4],
            enabled: true,
            message: "På torsdagar är det vagndag i Vasaparken, vilket innebär att vi har tillstånd för två vagnar mellan 8-18. Vagn 3&4 är reserverade för möte för tjänst 11:30. Vid frågor kontakta Rickard eller Meliza."
          },
          {
            id: "weekend",
            weekdays: [0, 6],
            enabled: true,
            message: "Vi har tillstånd för två vagnar i Vasaparken mellan 10-16. Övrig tid och plats flyttar vi vagnarna efter en kort stund. Vid frågor kontakta Rickard eller Meliza."
          },
          {
            id: "weekday",
            weekdays: [1, 2, 3, 5],
            enabled: true,
            message: "Vi har tillstånd för två vagnar i Vasaparken mellan 8-18. Övrig tid och plats flyttar vi vagnarna efter en kort stund. Vid frågor kontakta Rickard eller Meliza."
          }
        ]
      },
      homePageInfo: {
        enabled: false,
        title: "Just nu",
        message: ""
      },
      emailSettings: {
        enabled: true,
        serviceId: "",
        templateId: "",
        publicKey: ""
      }
    });

  const [editingMessage, setEditingMessage] = useState(null);
  const [newInfoMessage, setNewInfoMessage] = useState({
    id: "",
    weekdays: [],
    enabled: true,
    message: ""
  });
  const [reportMonth, setReportMonth] = useState('');
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    appConfig: false,
    homePageInfo: false,
    emailSettings: false,
    infoMessages: false,
    maintenanceBlocks: false,
    reports: false
  });

  registerLocale("sv", sv);
  setDefaultLocale("sv");

  const Select = (props) => (
    <FixRequiredSelect {...props} SelectComponent={BaseSelect} />
  );

  const weekdayOptions = [
    { label: "Måndag", value: 1 },
    { label: "Tisdag", value: 2 },
    { label: "Onsdag", value: 3 },
    { label: "Torsdag", value: 4 },
    { label: "Fredag", value: 5 },
    { label: "Lördag", value: 6 },
    { label: "Söndag", value: 0 }
  ];

  useEffect(() => {
    fetchMaintenanceBlocks();
    loadAppConfig();
  }, []);

  const handleLogout = () => {
    if (window.confirm('Är du säker på att du vill logga ut?')) {
      logout();
    }
  };

  const fetchMaintenanceBlocks = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "maintenance_blocks"));
      const blocks = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMaintenanceBlocks(blocks);
    } catch (error) {
      console.error("Error fetching maintenance blocks:", error);
    }
  };

  const loadAppConfig = async () => {
    try {
      const config = await ConfigService.loadConfig();
      // Ensure emailSettings exists with default values if not present
      if (!config.emailSettings) {
        config.emailSettings = {
          enabled: true,
          serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
          templateId: process.env.REACT_APP_EMAILJS_CONFIRM_TEMPLATE_ID || "",
          publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || ""
        };
      }
      setAppConfig(config);
    } catch (error) {
      console.error("Error loading app config:", error);
    }
  };

  const saveAppConfig = async () => {
    try {
      // Delete existing config
      const configQuery = query(
        collection(db, "app_config"),
        where("configType", "==", "main")
      );
      const querySnapshot = await getDocs(configQuery);
      
      for (const docSnapshot of querySnapshot.docs) {
        await deleteDoc(doc(db, "app_config", docSnapshot.id));
      }

      // Add new config
      await addDoc(collection(db, "app_config"), {
        configType: "main",
        config: appConfig,
        updatedAt: new Date().toISOString()
      });

      alert("Konfiguration sparad!");
    } catch (error) {
      console.error("Error saving app config:", error);
      alert("Fel vid sparande av konfiguration");
    }
  };

  const addMaintenanceBlock = async (e) => {
    e.preventDefault();
    
    try {
      const blockData = {
        ...newBlock,
        dateString: newBlock.date.toLocaleString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }),
        createdAt: new Date().toISOString()
      };

      await addDoc(collection(db, "maintenance_blocks"), blockData);
      
      setNewBlock({
        date: new Date(),
        startTime: "",
        endTime: "",
        cart: "",
        reason: "",
        type: "maintenance"
      });
      
      fetchMaintenanceBlocks();
      alert("Underhållsblock tillagt!");
    } catch (error) {
      console.error("Error adding maintenance block:", error);
      alert("Fel vid tillägg av underhållsblock");
    }
  };

  const removeMaintenanceBlock = async (blockId) => {
    if (window.confirm('Är du säker på att du vill ta bort detta underhållsblock?')) {
      try {
        await deleteDoc(doc(db, "maintenance_blocks", blockId));
        fetchMaintenanceBlocks();
        alert("Underhållsblock borttaget!");
      } catch (error) {
        console.error("Error removing maintenance block:", error);
        alert("Fel vid borttagning av underhållsblock");
      }
    }
  };

  const toggleInfoMessages = () => {
    setAppConfig({
      ...appConfig,
      infoMessages: {
        ...appConfig.infoMessages,
        enabled: !appConfig.infoMessages.enabled
      }
    });
  };

  const toggleInfoMessage = (messageId) => {
    setAppConfig({
      ...appConfig,
      infoMessages: {
        ...appConfig.infoMessages,
        messages: appConfig.infoMessages.messages.map(msg =>
          msg.id === messageId ? { ...msg, enabled: !msg.enabled } : msg
        )
      }
    });
  };

  const updateInfoMessage = (messageId, updatedMessage) => {
    setAppConfig({
      ...appConfig,
      infoMessages: {
        ...appConfig.infoMessages,
        messages: appConfig.infoMessages.messages.map(msg =>
          msg.id === messageId ? updatedMessage : msg
        )
      }
    });
  };

  const addNewInfoMessage = async () => {
    if (!newInfoMessage.id || !newInfoMessage.message || newInfoMessage.weekdays.length === 0) {
      alert("Fyll i alla fält för det nya meddelandet");
      return;
    }

    if (appConfig.infoMessages.messages.some(msg => msg.id === newInfoMessage.id)) {
      alert("Ett meddelande med detta ID finns redan");
      return;
    }

    const updatedConfig = {
      ...appConfig,
      infoMessages: {
        ...appConfig.infoMessages,
        messages: [...appConfig.infoMessages.messages, newInfoMessage]
      }
    };

    setAppConfig(updatedConfig);

    // Save to database
    try {
      const configQuery = query(
        collection(db, "app_config"),
        where("configType", "==", "main")
      );
      const querySnapshot = await getDocs(configQuery);
      
      for (const docSnapshot of querySnapshot.docs) {
        await deleteDoc(doc(db, "app_config", docSnapshot.id));
      }

      await addDoc(collection(db, "app_config"), {
        configType: "main",
        config: updatedConfig,
        updatedAt: new Date().toISOString()
      });

      alert("Meddelande tillagt och sparad!");
    } catch (error) {
      console.error("Error saving info message:", error);
      alert("Fel vid sparande av meddelande");
    }

    setNewInfoMessage({
      id: "",
      weekdays: [],
      enabled: true,
      message: ""
    });
  };

  const removeInfoMessage = async (messageId) => {
    if (!window.confirm('Är du säker på att du vill ta bort detta meddelande?')) {
      return;
    }

    const updatedConfig = {
      ...appConfig,
      infoMessages: {
        ...appConfig.infoMessages,
        messages: appConfig.infoMessages.messages.filter(msg => msg.id !== messageId)
      }
    };

    setAppConfig(updatedConfig);

    // Save to database
    try {
      const configQuery = query(
        collection(db, "app_config"),
        where("configType", "==", "main")
      );
      const querySnapshot = await getDocs(configQuery);
      
      for (const docSnapshot of querySnapshot.docs) {
        await deleteDoc(doc(db, "app_config", docSnapshot.id));
      }

      await addDoc(collection(db, "app_config"), {
        configType: "main",
        config: updatedConfig,
        updatedAt: new Date().toISOString()
      });

      alert("Meddelande borttaget!");
    } catch (error) {
      console.error("Error removing info message:", error);
      alert("Fel vid borttagning av meddelande");
    }
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let i = 0; i <= 23; i++) {
      for (let j = 0; j < 60; j += 30) {
        const time = `${i.toString().padStart(2, "0")}:${j
          .toString()
          .padStart(2, "0")}`;
        options.push({ label: time, value: time });
      }
    }
    return options;
  };

  const cartOptions = appConfig.availableCarts.map(cart => ({
    label: cart.name,
    value: cart.id
  }));

  const blockTypeOptions = [
    { label: "Underhåll", value: "maintenance" },
    { label: "Reparation", value: "repair" },
    { label: "Inspektion", value: "inspection" },
    { label: "Annat", value: "other" }
  ];

  const getWeekdayNames = (weekdays) => {
    return weekdays.map(day => 
      weekdayOptions.find(option => option.value === day)?.label
    ).join(", ");
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const generateMonthOptions = () => {
    const options = [{ label: "Alla tider", value: "all" }];
    const currentDate = new Date();
    
    // Generate last 12 months
    for (let i = 0; i < 12; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const monthYear = date.toLocaleDateString('sv-SE', { year: 'numeric', month: 'long' });
      const value = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
      options.push({ label: monthYear, value });
    }
    
    return options;
  };

  const fetchBookingsForReport = async (selectedMonth) => {
    try {
      const bookingsQuery = collection(db, "booking");
      const querySnapshot = await getDocs(bookingsQuery);
      let bookings = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filter by month if not "all"
      if (selectedMonth !== "all") {
        const [year, month] = selectedMonth.split('-');
        bookings = bookings.filter(booking => {
          const bookingDate = new Date(booking.date.replace(" at", "").replace("CEST", "GMT+0200").replace("CET", "GMT+0100"));
          return bookingDate.getFullYear() === parseInt(year) && 
                 (bookingDate.getMonth() + 1) === parseInt(month);
        });
      }

      return bookings;
    } catch (error) {
      console.error("Error fetching bookings for report:", error);
      return [];
    }
  };

  const generatePDFReport = async () => {
    if (!reportMonth) {
      alert("Välj en månad för rapporten");
      return;
    }

    setIsGeneratingReport(true);

    try {
      const bookings = await fetchBookingsForReport(reportMonth);
      
      // Calculate statistics
      const stats = {
        totalBookings: bookings.length,
        totalHours: bookings.reduce((sum, booking) => sum + (booking.duration || 0), 0),
        cartStats: {},
        monthlyData: {}
      };

      // Calculate cart statistics
      appConfig.availableCarts.forEach(cart => {
        const cartBookings = bookings.filter(b => b.cart === cart.id);
        stats.cartStats[cart.name] = {
          bookings: cartBookings.length,
          hours: cartBookings.reduce((sum, booking) => sum + (booking.duration || 0), 0),
          percentage: bookings.length > 0 ? ((cartBookings.length / bookings.length) * 100).toFixed(1) : 0
        };
      });

      // Group bookings by month for trend analysis
      bookings.forEach(booking => {
        const date = new Date(booking.date.replace(" at", "").replace("CEST", "GMT+0200").replace("CET", "GMT+0100"));
        const monthKey = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
        if (!stats.monthlyData[monthKey]) {
          stats.monthlyData[monthKey] = { bookings: 0, hours: 0 };
        }
        stats.monthlyData[monthKey].bookings++;
        stats.monthlyData[monthKey].hours += booking.duration || 0;
      });

      // Create PDF
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.width;
      
      // Title
      doc.setFontSize(20);
      doc.setFont(undefined, 'bold');
      const title = reportMonth === 'all' ? 'Bokningsrapport - Alla tider' : 
                    `Bokningsrapport - ${generateMonthOptions().find(opt => opt.value === reportMonth)?.label}`;
      doc.text(title, pageWidth / 2, 20, { align: 'center' });
      
      // Generation date
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Genererad: ${new Date().toLocaleDateString('sv-SE')}`, pageWidth / 2, 30, { align: 'center' });

      let yPosition = 50;

      // Summary statistics
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.text('Sammanfattning', 14, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont(undefined, 'normal');
      doc.text(`Totalt antal bokningar: ${stats.totalBookings}`, 14, yPosition);
      yPosition += 7;
      doc.text(`Totalt antal timmar: ${stats.totalHours.toFixed(1)}`, 14, yPosition);
      yPosition += 7;
      doc.text(`Genomsnittlig bokningstid: ${stats.totalBookings > 0 ? (stats.totalHours / stats.totalBookings).toFixed(1) : 0} timmar`, 14, yPosition);
      yPosition += 15;

      // Cart statistics table
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.text('Statistik per vagn', 14, yPosition);
      yPosition += 10;

      const cartTableData = Object.entries(stats.cartStats).map(([cartName, data]) => [
        cartName,
        data.bookings.toString(),
        `${data.hours.toFixed(1)}h`,
        `${data.percentage}%`
      ]);

      autoTable(doc, {
        startY: yPosition,
        head: [['Vagn', 'Antal bokningar', 'Totala timmar', 'Andel av bokningar']],
        body: cartTableData,
        theme: 'grid',
        headStyles: { fillColor: [220, 53, 69] },
        styles: { fontSize: 10 }
      });

      yPosition = doc.lastAutoTable.finalY + 20;

      // Monthly trend (if showing all time)
      if (reportMonth === 'all' && Object.keys(stats.monthlyData).length > 1) {
        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.text('Månadsvis trend', 14, yPosition);
        yPosition += 10;

        const monthlyTableData = Object.entries(stats.monthlyData)
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([month, data]) => {
            const [year, monthNum] = month.split('-');
            const monthName = new Date(year, monthNum - 1).toLocaleDateString('sv-SE', { year: 'numeric', month: 'long' });
            return [monthName, data.bookings.toString(), `${data.hours.toFixed(1)}h`];
          });

        autoTable(doc, {
          startY: yPosition,
          head: [['Månad', 'Antal bokningar', 'Totala timmar']],
          body: monthlyTableData,
          theme: 'grid',
          headStyles: { fillColor: [220, 53, 69] },
          styles: { fontSize: 10 }
        });

        yPosition = doc.lastAutoTable.finalY + 20;
      }

      // Detailed bookings table
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
      }

      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.text('Detaljerade bokningar', 14, yPosition);
      yPosition += 10;

      const bookingTableData = bookings
        .sort((a, b) => {
          // Safe date parsing with fallback
          const dateA = new Date(a.date.replace(" at", "").replace("CEST", "GMT+0200").replace("CET", "GMT+0100"));
          const dateB = new Date(b.date.replace(" at", "").replace("CEST", "GMT+0200").replace("CET", "GMT+0100"));
    
          // If either date is invalid, sort them to the end
          if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
          if (isNaN(dateA.getTime())) return 1;
          if (isNaN(dateB.getTime())) return -1;
    
          return dateA - dateB;
        })
        .map(booking => {
          let formattedDate;
    
          // Try to parse the date and check if it's valid
          const parsedDate = new Date(booking.date.replace(" at", "").replace("CEST", "GMT+0200").replace("CET", "GMT+0100"));
    
          if (isNaN(parsedDate.getTime())) {
            // Invalid date - show the original format for debugging
            formattedDate = `INVALID: ${booking.date}`;
            console.warn('Invalid date format found:', booking.date);
          } else {
            // Valid date - format it properly
            formattedDate = parsedDate.toLocaleDateString('sv-SE');
          }
    
          return [
            formattedDate,
            booking.starttime || '',
            `${booking.duration || 0}h`,
            appConfig.availableCarts.find(cart => cart.id === booking.cart)?.name || booking.cart,
            booking.persons || '',
            (booking.location || '').substring(0, 30) + ((booking.location || '').length > 30 ? '...' : '')
          ];
        });

      autoTable(doc, {
        startY: yPosition,
        head: [['Datum', 'Tid', 'Längd', 'Vagn', 'Personer', 'Plats']],
        body: bookingTableData,
        theme: 'grid',
        headStyles: { fillColor: [220, 53, 69] },
        styles: { fontSize: 8 },
        columnStyles: {
          5: { cellWidth: 40 } // Limit location column width
        }
      });

      // Save the PDF
      const fileName = reportMonth === 'all' ? 
        `bokningsrapport_alla_tider_${new Date().toISOString().split('T')[0]}.pdf` :
        `bokningsrapport_${reportMonth}_${new Date().toISOString().split('T')[0]}.pdf`;
      
      doc.save(fileName);
      
      alert("Rapport genererad och nedladdad!");

    } catch (error) {
      console.error("Error generating report:", error);
      alert("Fel vid generering av rapport");
    } finally {
      setIsGeneratingReport(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8 animate-fade-in">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2 flex items-center">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                  <FaTools className="text-red-600 text-xl" />
                </div>
                Admin Panel
              </h2>
              <p className="text-gray-600 ml-16">Hantera inställningar och underhåll</p>
            </div>
            <button
              onClick={handleLogout}
              className="btn-secondary flex items-center"
            >
              <FaSignOutAlt className="mr-2 flex-shrink-0" />
              <span>Logga Ut</span>
            </button>
          </div>
        </div>

        {/* App Configuration Section */}
        <div className="card mb-6 animate-slide-up">
          <div className="flex items-center justify-between mb-0">
            <button
              onClick={() => toggleSection('appConfig')}
              className="flex items-center flex-1 text-left hover:opacity-80 transition-opacity"
            >
              <h3 className="text-xl font-bold flex items-center text-gray-900">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <FaEdit className="text-blue-600" />
                </div>
                Applikationsinställningar
              </h3>
              <div className="ml-auto mr-4">
                {expandedSections.appConfig ? (
                  <FaChevronUp className="text-gray-400" />
                ) : (
                  <FaChevronDown className="text-gray-400" />
                )}
              </div>
            </button>
            {expandedSections.appConfig && (
              <button
                onClick={saveAppConfig}
                className="btn-primary"
              >
                <FaSave className="mr-2 flex-shrink-0" />
                <span>Spara</span>
              </button>
            )}
          </div>
          
          {expandedSections.appConfig && (
            <div className="mt-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="label">
                Tjänstens namn
              </label>
              <input
                type="text"
                value={appConfig.serviceName}
                onChange={(e) => setAppConfig({...appConfig, serviceName: e.target.value})}
                className="input-field"
              />
            </div>
            
            <div>
              <label className="label">
                Max bokningsdagar framåt
              </label>
              <input
                type="number"
                value={appConfig.maxBookingDays}
                onChange={(e) => setAppConfig({...appConfig, maxBookingDays: parseInt(e.target.value)})}
                className="input-field"
              />
            </div>
            
            <div>
              <label className="label">
                Vardagar starttid
              </label>
              <input
                type="number"
                min="0"
                max="23"
                value={appConfig.weekdayStartHour}
                onChange={(e) => setAppConfig({...appConfig, weekdayStartHour: parseInt(e.target.value)})}
                className="input-field"
              />
            </div>
            
            <div>
              <label className="label">
                Vardagar sluttid
              </label>
              <input
                type="number"
                min="0"
                max="23"
                value={appConfig.weekdayEndHour}
                onChange={(e) => setAppConfig({...appConfig, weekdayEndHour: parseInt(e.target.value)})}
                className="input-field"
              />
            </div>

            <div>
              <label className="label">
                Helger starttid
              </label>
              <input
                type="number"
                min="0"
                max="23"
                value={appConfig.weekendStartHour}
                onChange={(e) => setAppConfig({...appConfig, weekendStartHour: parseInt(e.target.value)})}
                className="input-field"
              />
            </div>
            
            <div>
              <label className="label">
                Helger sluttid
              </label>
              <input
                type="number"
                min="0"
                max="23"
                value={appConfig.weekendEndHour}
                onChange={(e) => setAppConfig({...appConfig, weekendEndHour: parseInt(e.target.value)})}
                className="input-field"
              />
            </div>

            <div>
              <label className="label">
                Max bokningstid (timmar)
              </label>
              <input
                type="number"
                step="0.5"
                min="0.5"
                max="8"
                value={appConfig.maxBookingDuration}
                onChange={(e) => setAppConfig({...appConfig, maxBookingDuration: parseFloat(e.target.value)})}
                className="input-field"
              />
            </div>

            <div className="flex items-center">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={appConfig.thursdaySpecialRules}
                  onChange={(e) => setAppConfig({...appConfig, thursdaySpecialRules: e.target.checked})}
                  className="h-5 w-5 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
                />
                <span className="ml-3 text-sm font-medium text-gray-700">
                  Aktivera speciella torsdagsregler
                </span>
              </label>
              </div>
            </div>
            </div>
          )}
        </div>

        {/* Home Page Info Section */}
        <div className="card mb-6 animate-slide-up">
          <div className="flex items-center justify-between mb-0">
            <button
              onClick={() => toggleSection('homePageInfo')}
              className="flex items-center flex-1 text-left hover:opacity-80 transition-opacity"
            >
              <h3 className="text-xl font-bold flex items-center text-gray-900">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                  <FaInfoCircle className="text-green-600" />
                </div>
                Infotext för Startsidan
              </h3>
              <div className="ml-auto mr-4">
                {expandedSections.homePageInfo ? (
                  <FaChevronUp className="text-gray-400" />
                ) : (
                  <FaChevronDown className="text-gray-400" />
                )}
              </div>
            </button>
            {expandedSections.homePageInfo && (
              <button
                onClick={saveAppConfig}
                className="btn-primary"
              >
                <FaSave className="mr-2 flex-shrink-0" />
                <span>Spara</span>
              </button>
            )}
          </div>
          
          {expandedSections.homePageInfo && (
            <div className="mt-6 space-y-4">
            <div className="flex items-center">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={appConfig.homePageInfo?.enabled || false}
                  onChange={(e) => setAppConfig({
                    ...appConfig, 
                    homePageInfo: {
                      ...appConfig.homePageInfo,
                      enabled: e.target.checked,
                      title: appConfig.homePageInfo?.title || "Just nu",
                      message: appConfig.homePageInfo?.message || ""
                    }
                  })}
                  className="h-5 w-5 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
                />
                <span className="ml-3 text-sm font-medium text-gray-700">
                  Aktivera infotext på startsidan
                </span>
              </label>
            </div>

            {appConfig.homePageInfo?.enabled && (
              <>
                <div>
                  <label className="label">
                    Titel (t.ex. "Just nu", "Info", "Viktigt")
                  </label>
                  <input
                    type="text"
                    value={appConfig.homePageInfo?.title || ""}
                    onChange={(e) => setAppConfig({
                      ...appConfig,
                      homePageInfo: {
                        ...appConfig.homePageInfo,
                        title: e.target.value,
                        enabled: appConfig.homePageInfo?.enabled || false,
                        message: appConfig.homePageInfo?.message || ""
                      }
                    })}
                    className="input-field"
                    placeholder="Just nu"
                  />
                </div>
                
                <div>
                  <label className="label">
                    Meddelande
                  </label>
                  <textarea
                    value={appConfig.homePageInfo?.message || ""}
                    onChange={(e) => setAppConfig({
                      ...appConfig,
                      homePageInfo: {
                        ...appConfig.homePageInfo,
                        message: e.target.value,
                        enabled: appConfig.homePageInfo?.enabled || false,
                        title: appConfig.homePageInfo?.title || "Just nu"
                      }
                    })}
                    className="input-field h-32 resize-none"
                    placeholder="Skriv ditt meddelande här..."
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Meddelandet visas bara om det är ifyllt. Lämna tomt för att dölja.
                  </p>
                </div>
              </>
            )}
            </div>
          )}
        </div>

        {/* Email Settings Section */}
        <div className="card mb-6 animate-slide-up">
          <div className="flex items-center justify-between mb-0">
            <button
              onClick={() => toggleSection('emailSettings')}
              className="flex items-center flex-1 text-left hover:opacity-80 transition-opacity"
            >
              <h3 className="text-xl font-bold flex items-center text-gray-900">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <IoMail className="text-blue-600" />
                </div>
                E-postinställningar
              </h3>
              <div className="ml-auto mr-4">
                {expandedSections.emailSettings ? (
                  <FaChevronUp className="text-gray-400" />
                ) : (
                  <FaChevronDown className="text-gray-400" />
                )}
              </div>
            </button>
            {expandedSections.emailSettings && (
              <button
                onClick={saveAppConfig}
                className="btn-primary"
              >
                <FaSave className="mr-2 flex-shrink-0" />
                <span>Spara</span>
              </button>
            )}
          </div>
          
          {expandedSections.emailSettings && (
            <div className="mt-6 space-y-4">
              <div className="mb-6 flex items-center">
                <button
                  onClick={() => setAppConfig({
                    ...appConfig,
                    emailSettings: {
                      ...appConfig.emailSettings,
                      enabled: !appConfig.emailSettings?.enabled
                    }
                  })}
                  className={`flex items-center px-4 py-2 rounded-lg transition-all duration-200 ${
                    appConfig.emailSettings?.enabled 
                      ? 'bg-green-600 hover:bg-green-700 text-white shadow-sm' 
                      : 'bg-gray-400 hover:bg-gray-500 text-white shadow-sm'
                  }`}
                >
                  {appConfig.emailSettings?.enabled ? <FaToggleOn className="mr-2 text-xl" /> : <FaToggleOff className="mr-2 text-xl" />}
                  E-postutskick {appConfig.emailSettings?.enabled ? 'Aktiverat' : 'Inaktiverat'}
                </button>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                <p className="text-sm text-gray-600 mb-4">
                  När e-postutskick är aktiverat kommer bekräftelsemail att skickas automatiskt vid bokning. 
                  Om det är inaktiverat kommer inga email att skickas, även om användaren anger en e-postadress.
                </p>
                
                {appConfig.emailSettings?.enabled && (
                  <div className="space-y-4">
                    <div>
                      <label className="label">
                        EmailJS Service ID
                      </label>
                      <input
                        type="text"
                        value={appConfig.emailSettings?.serviceId || ""}
                        onChange={(e) => setAppConfig({
                          ...appConfig,
                          emailSettings: {
                            ...appConfig.emailSettings,
                            serviceId: e.target.value,
                            enabled: appConfig.emailSettings?.enabled || false,
                            templateId: appConfig.emailSettings?.templateId || "",
                            publicKey: appConfig.emailSettings?.publicKey || ""
                          }
                        })}
                        className="input-field"
                        placeholder="EmailJS Service ID"
                      />
                    </div>
                    
                    <div>
                      <label className="label">
                        EmailJS Template ID
                      </label>
                      <input
                        type="text"
                        value={appConfig.emailSettings?.templateId || ""}
                        onChange={(e) => setAppConfig({
                          ...appConfig,
                          emailSettings: {
                            ...appConfig.emailSettings,
                            templateId: e.target.value,
                            enabled: appConfig.emailSettings?.enabled || false,
                            serviceId: appConfig.emailSettings?.serviceId || "",
                            publicKey: appConfig.emailSettings?.publicKey || ""
                          }
                        })}
                        className="input-field"
                        placeholder="EmailJS Template ID"
                      />
                    </div>
                    
                    <div>
                      <label className="label">
                        EmailJS Public Key
                      </label>
                      <input
                        type="text"
                        value={appConfig.emailSettings?.publicKey || ""}
                        onChange={(e) => setAppConfig({
                          ...appConfig,
                          emailSettings: {
                            ...appConfig.emailSettings,
                            publicKey: e.target.value,
                            enabled: appConfig.emailSettings?.enabled || false,
                            serviceId: appConfig.emailSettings?.serviceId || "",
                            templateId: appConfig.emailSettings?.templateId || ""
                          }
                        })}
                        className="input-field"
                        placeholder="EmailJS Public Key"
                      />
                    </div>
                    
                    <p className="text-xs text-gray-500 mt-2">
                      Dessa värden kan också sättas via miljövariabler (REACT_APP_EMAILJS_SERVICE_ID, etc.) 
                      vilket kommer att åsidosätta dessa inställningar.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Info Messages Management Section */}
        <div className="card mb-6 animate-slide-up">
          <div className="flex items-center justify-between mb-0">
            <button
              onClick={() => toggleSection('infoMessages')}
              className="flex items-center flex-1 text-left hover:opacity-80 transition-opacity"
            >
              <h3 className="text-xl font-bold flex items-center text-gray-900">
                <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center mr-3">
                  <FaInfoCircle className="text-yellow-600" />
                </div>
                Informationsmeddelanden
              </h3>
              <div className="ml-auto mr-4">
                {expandedSections.infoMessages ? (
                  <FaChevronUp className="text-gray-400" />
                ) : (
                  <FaChevronDown className="text-gray-400" />
                )}
              </div>
            </button>
            {expandedSections.infoMessages && (
              <button
                onClick={saveAppConfig}
                className="btn-primary"
              >
                <FaSave className="mr-2 flex-shrink-0" />
                <span>Spara</span>
              </button>
            )}
          </div>
          
          {expandedSections.infoMessages && (
            <div className="mt-6">
              <div className="mb-6 flex items-center">
            <button
              onClick={toggleInfoMessages}
              className={`flex items-center px-4 py-2 rounded-lg transition-all duration-200 ${
                appConfig.infoMessages.enabled 
                  ? 'bg-green-600 hover:bg-green-700 text-white shadow-sm' 
                  : 'bg-gray-400 hover:bg-gray-500 text-white shadow-sm'
              }`}
            >
              {appConfig.infoMessages.enabled ? <FaToggleOn className="mr-2 text-xl" /> : <FaToggleOff className="mr-2 text-xl" />}
              Informationsmeddelanden {appConfig.infoMessages.enabled ? 'Aktiverade' : 'Inaktiverade'}
            </button>
          </div>

          {/* Add New Info Message */}
          <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200">
            <h4 className="font-medium mb-3">Lägg till nytt meddelande</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="label">
                  ID (unikt namn)
                </label>
                <input
                  type="text"
                  value={newInfoMessage.id}
                  onChange={(e) => setNewInfoMessage({...newInfoMessage, id: e.target.value})}
                  className="input-field"
                  placeholder="t.ex. 'monday_special'"
                />
              </div>
              
              <div>
                <label className="label">
                  Veckodagar
                </label>
                <Select
                  isMulti
                  value={weekdayOptions.filter(option => newInfoMessage.weekdays.includes(option.value))}
                  onChange={(selectedOptions) => 
                    setNewInfoMessage({
                      ...newInfoMessage, 
                      weekdays: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                    })
                  }
                  options={weekdayOptions}
                  placeholder="Välj veckodagar"
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
            </div>
            
            <div className="mt-4">
              <label className="label">
                Meddelande
              </label>
              <textarea
                value={newInfoMessage.message}
                onChange={(e) => setNewInfoMessage({...newInfoMessage, message: e.target.value})}
                className="input-field h-24 resize-none"
                placeholder="Skriv ditt informationsmeddelande här..."
              />
            </div>
            
            <button
              onClick={addNewInfoMessage}
              className="btn-primary mt-4"
            >
              <FaPlus className="mr-2 flex-shrink-0" />
              <span>Lägg till meddelande</span>
            </button>
          </div>

          {/* Existing Info Messages */}
          <div className="space-y-4">
            {appConfig.infoMessages.messages.map((message) => (
              <div key={message.id} className="border border-gray-200 rounded-lg p-4 bg-white hover:shadow-md transition-shadow">
                {editingMessage === message.id ? (
                  <div className="space-y-3">
                    <div>
                      <label className="label">
                        Veckodagar
                      </label>
                      <Select
                        isMulti
                        value={weekdayOptions.filter(option => message.weekdays.includes(option.value))}
                        onChange={(selectedOptions) => {
                          const updatedMessage = {
                            ...message,
                            weekdays: selectedOptions ? selectedOptions.map(opt => opt.value) : []
                          };
                          updateInfoMessage(message.id, updatedMessage);
                        }}
                        options={weekdayOptions}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>
                    
                    <div>
                      <label className="label">
                        Meddelande
                      </label>
                      <textarea
                        value={message.message}
                        onChange={(e) => {
                          const updatedMessage = { ...message, message: e.target.value };
                          setAppConfig({
                            ...appConfig,
                            infoMessages: {
                              ...appConfig.infoMessages,
                              messages: appConfig.infoMessages.messages.map(msg =>
                                msg.id === message.id ? updatedMessage : msg
                              )
                            }
                          });
                        }}
                        className="input-field h-24 resize-none"
                      />
                    </div>
                    
                    <div className="flex space-x-2">
                      <button
                        onClick={async () => {
                          await saveAppConfig();
                          setEditingMessage(null);
                        }}
                        className="btn-primary text-sm"
                      >
                        <FaSave className="mr-2 flex-shrink-0" />
                        <span>Spara</span>
                      </button>
                      <button
                        onClick={() => setEditingMessage(null)}
                        className="btn-secondary text-sm"
                      >
                        Avbryt
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center mb-2">
                        <h5 className="font-medium text-gray-800 mr-3">
                          {message.id}
                        </h5>
                        <span className="text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded">
                          {getWeekdayNames(message.weekdays)}
                        </span>
                        <button
                          onClick={() => toggleInfoMessage(message.id)}
                          className={`ml-3 text-sm px-2 py-1 rounded ${
                            message.enabled 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {message.enabled ? 'Aktiv' : 'Inaktiv'}
                        </button>
                      </div>
                      <p className="text-sm text-gray-600 mb-2">
                        {message.message}
                      </p>
                    </div>
                    <div className="flex space-x-2 ml-4">
                      <button
                        onClick={() => setEditingMessage(message.id)}
                        className="text-blue-600 hover:text-blue-800 transition duration-300"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => removeInfoMessage(message.id)}
                        className="text-red-600 hover:text-red-800 transition duration-300"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>
                )}
              </div>
              ))}
            </div>
            </div>
          )}
        </div>

        {/* Maintenance Blocks Section */}
        <div className="card mb-6 animate-slide-up">
          <div className="flex items-center justify-between mb-0">
            <button
              onClick={() => toggleSection('maintenanceBlocks')}
              className="flex items-center flex-1 text-left hover:opacity-80 transition-opacity"
            >
              <h3 className="text-xl font-bold flex items-center text-gray-900">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                  <FaTools className="text-orange-600" />
                </div>
                Underhållsblock
              </h3>
              <div className="ml-auto">
                {expandedSections.maintenanceBlocks ? (
                  <FaChevronUp className="text-gray-400" />
                ) : (
                  <FaChevronDown className="text-gray-400" />
                )}
              </div>
            </button>
          </div>
          
          {expandedSections.maintenanceBlocks && (
            <div className="mt-6">
              <p className="text-sm text-gray-600 mb-6">
                Blockera vagnar för underhåll, reparationer eller andra ändamål. Blockade vagnar visas inte som tillgängliga vid bokning.
              </p>
              
              {/* Add New Maintenance Block */}
          <div className="bg-gray-50 p-6 rounded-lg mb-6 border border-gray-200">
            <h4 className="font-medium mb-3">Lägg till underhållsblock</h4>
            <form onSubmit={addMaintenanceBlock}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="label flex items-center">
                    <FaCalendarAlt className="mr-2 text-primary-600" />
                    Datum
                  </label>
                  <DatePicker
                    selected={newBlock.date}
                    onChange={(date) => setNewBlock({...newBlock, date})}
                    className="input-field"
                    dateFormat="yyyy/dd/MM"
                    locale="sv"
                    required
                  />
                </div>
                
                <div>
                  <label className="label">
                    Vagn
                  </label>
                  <Select
                    value={cartOptions.find(option => option.value === newBlock.cart)}
                    onChange={(option) => setNewBlock({...newBlock, cart: option.value})}
                    options={cartOptions}
                    placeholder="Välj vagn"
                    required
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
                
                <div>
                  <label className="label flex items-center">
                    <FaClock className="mr-2 text-primary-600" />
                    Starttid
                  </label>
                  <Select
                    value={generateTimeOptions().find(option => option.value === newBlock.startTime)}
                    onChange={(option) => setNewBlock({...newBlock, startTime: option.value})}
                    options={generateTimeOptions()}
                    placeholder="Välj starttid"
                    required
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
                
                <div>
                  <label className="label">
                    Sluttid
                  </label>
                  <Select
                    value={generateTimeOptions().find(option => option.value === newBlock.endTime)}
                    onChange={(option) => setNewBlock({...newBlock, endTime: option.value})}
                    options={generateTimeOptions()}
                    placeholder="Välj sluttid"
                    required
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
                
                <div>
                  <label className="label">
                    Typ
                  </label>
                  <Select
                    value={blockTypeOptions.find(option => option.value === newBlock.type)}
                    onChange={(option) => setNewBlock({...newBlock, type: option.value})}
                    options={blockTypeOptions}
                    placeholder="Välj typ"
                    required
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>
                
                <div>
                  <label className="label">
                    Anledning
                  </label>
                  <input
                    type="text"
                    value={newBlock.reason}
                    onChange={(e) => setNewBlock({...newBlock, reason: e.target.value})}
                    className="input-field"
                    placeholder="Beskriv anledningen"
                    required
                  />
                </div>
              </div>
              
              <button
                type="submit"
                className="btn-danger mt-6"
              >
                <FaPlus className="mr-2 flex-shrink-0" />
                <span>Lägg till Block</span>
              </button>
            </form>
          </div>

          {/* Current Maintenance Blocks */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-gray-900">Aktiva Underhållsblock</h4>
            
            {maintenanceBlocks.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
                <FaTools className="text-4xl text-gray-300 mx-auto mb-3" />
                <p className="text-gray-500">Inga underhållsblock finns för närvarande.</p>
              </div>
            ) : (
              <div className="space-y-3">
                {maintenanceBlocks.map((block) => (
                  <div key={block.id} className="border border-gray-200 rounded-lg p-4 flex justify-between items-center bg-white hover:shadow-md transition-shadow">
                    <div>
                      <div className="font-medium">
                        {block.dateString} | {block.startTime} - {block.endTime}
                      </div>
                      <div className="text-sm text-gray-600">
                        {appConfig.availableCarts.find(cart => cart.id === block.cart)?.name} - {block.reason} ({block.type})
                      </div>
                    </div>
                    <button
                      onClick={() => removeMaintenanceBlock(block.id)}
                      className="text-red-600 hover:text-red-800 transition duration-300"
                    >
                      <FaTrash />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
            </div>
          )}
        </div>

        {/* Report Generation Section */}
        <div className="card mb-6 animate-slide-up">
          <div className="flex items-center justify-between mb-0">
            <button
              onClick={() => toggleSection('reports')}
              className="flex items-center flex-1 text-left hover:opacity-80 transition-opacity"
            >
              <h3 className="text-xl font-bold flex items-center text-gray-900">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
                  <FaClipboardList className="text-purple-600" />
                </div>
                Rapportgenerering
              </h3>
              <div className="ml-auto">
                {expandedSections.reports ? (
                  <FaChevronUp className="text-gray-400" />
                ) : (
                  <FaChevronDown className="text-gray-400" />
                )}
              </div>
            </button>
          </div>
          
          {expandedSections.reports && (
            <div className="mt-6">
              <p className="text-sm text-gray-600 mb-6">
                Generera PDF-rapporter med statistik över bokningar, inklusive totala timmar per vagn och bokningsfrekvens.
              </p>
              
              <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
            <h4 className="font-medium mb-3">Generera bokningsrapport</h4>
            <p className="text-sm text-gray-600 mb-4">
              Skapa en detaljerad PDF-rapport med statistik över bokningar, inklusive totala timmar per vagn, 
              bokningsfrekvens och fullständig bokningslista.
            </p>
            
            <div className="flex flex-col sm:flex-row sm:items-end sm:space-x-4 space-y-4 sm:space-y-0">
              <div className="flex-1">
                <label className="label">
                  Välj tidsperiod
                </label>
                <Select
                  value={generateMonthOptions().find(option => option.value === reportMonth)}
                  onChange={(option) => setReportMonth(option.value)}
                  options={generateMonthOptions()}
                  placeholder="Välj månad eller alla tider"
                  required
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
              
              <button
                onClick={generatePDFReport}
                disabled={isGeneratingReport || !reportMonth}
                className="btn-primary flex-shrink-0"
              >
                {isGeneratingReport ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 flex-shrink-0"></div>
                    <span>Genererar...</span>
                  </>
                ) : (
                  <>
                    <FaClipboardList className="mr-2 flex-shrink-0" />
                    <span>Generera rapport</span>
                  </>
                )}
              </button>
            </div>
            
            <div className="mt-3 text-xs text-gray-500">
              <p>Rapporten innehåller:</p>
              <ul className="list-disc list-inside mt-1 space-y-1">
                <li>Sammanfattande statistik (totala bokningar och timmar)</li>
                <li>Statistik per vagn (antal bokningar, timmar, procentuell fördelning)</li>
                <li>Månadsvis trend (endast för "alla tider")</li>
                <li>Detaljerad lista över alla bokningar</li>
              </ul>
            </div>
          </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPage;